export enum PreferredCarrierEnum {
  MERCURY = 'MERCURY',
  FEDEX = 'FEDEX',
  UPS = 'UPS',
}
